require("prismjs/themes/prism-okaidia.min.css")

document.body.setAttribute("data-scroll", 0)
